import styled from 'styled-components';
import { StyledSVG } from '@common/styles';
import { ComponentWrap, InputWrap, StyledLabel } from './Input/styles';
import { StyledButton } from './Button/styles';
import { ReactSVG } from 'react-svg';

export const RemoveButton = styled.div`
  cursor: pointer;
  ${StyledSVG} {
    svg {
      height: 26px;
      width: 26px;
    }
  }
`;

export const InputButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 30px;
  max-width: 390px;

  ${ComponentWrap} {
    flex: 1;
  }

  ${InputWrap} {
    height: 45px;
    border-color: ${({ theme }) => theme.elements.borderGrey};
    border-radius: 10px;
  }

  ${StyledLabel} {
    margin-bottom: 10px;
  }

  ${StyledButton} {
    height: 45px;
    width: 100px;
    margin-left: 10px;
    border-color: ${({ theme }) => theme.colors.mediumBlue};
    color: ${({ theme }) => theme.colors.mediumBlue};
  }
`;

export const GroupedCheckboxSections = styled.div`
  display: flex;
  flex-flow: column;
  row-gap: 20px;
`;

interface IModalTitleIcon {
  width?: number;
}

export const ModalTitleIcon = styled(ReactSVG)<IModalTitleIcon>`
  svg {
    width: ${({ width }) => (width ? width : 70)}px;
    height: auto;
  }

  margin-bottom: 5px;
`;

export const ModalTitle = styled.div`
  font-size: 22px;
  color: ${({ theme }) => theme.elements.textGrey};
  font-weight: 600;
  text-align: 'left';
  white-space: pre;
  margin-bottom: 0.5rem;
`;

export const ModalSubtext = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.elements.textLightGrey};
  text-align: left;
  white-space: pre;
  margin-bottom: 1rem;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
`;
